import type { LayerKey } from '@festina-life/api'
import { useTranslate } from '@festina-life/ui/hooks'

import { useLayoutContext } from '../../../context/layoutContext'
import type { ConfigurationTemplateFunctionValue } from '../../../types/templateModel'
import { TemplatePath } from '../../path/TemplatePath'

type Props = {
  data: ConfigurationTemplateFunctionValue
  layer: LayerKey
  block: string
}

export const TemplateFunctionTitle = ({ data, layer, block }: Props) => {
  const translate = useTranslate()
  const {
    preferences: { common },
  } = useLayoutContext()

  return (
    <div className="flex w-full flex-col gap-y-2">
      <div>
        <TemplatePath
          layer={layer}
          block={block}
          value={data.path}
          shouldRenderTemplateId={false}
          className="text-sm"
          variant={common.isUsingModal ? 'contrast' : 'normal'}
          isInteractive
        />
      </div>
      <div className="font-medium">{translate('valueSetup.role.function')}</div>
    </div>
  )
}
